import PropTypes from "prop-types"
import { areaAttendeeRestrictionToString } from "./areaRestriction"

const AreaDropdown = ({ menuItem, showRestrictions = true, attendee = null }) => {
  return (
    <div
      css={{
        cursor: menuItem.isDisabled ? "not-allowed" : "inherit"
      }}
    >
      {menuItem.name}
      <div
        css={{
          fontSize: "12px",
          color: menuItem.isDisabled ? "var(--color--neutral-500)" : "var(--color--neutral-400)"
        }}
      >
        {showRestrictions && areaAttendeeRestrictionToString(menuItem, attendee)}
      </div>
    </div>
  )
}

AreaDropdown.propTypes = {
  showRestrictions: PropTypes.bool,
  menuItem: PropTypes.shape({
    name: PropTypes.string,
    minGrade: PropTypes.number,
    maxGrade: PropTypes.number,
    minAge: PropTypes.number,
    maxAge: PropTypes.number,
    gender: PropTypes.string,
    restrictionType: PropTypes.string,
    capacityRemaining: PropTypes.number,
    ageRestrictionUnit: PropTypes.string,
    isDisabled: PropTypes.bool
  }),
  attendee: PropTypes.shape({})
}

export default AreaDropdown
